import { User } from '@topconagriculture/frontend-utils';
import { graphqlClient } from '@topconagriculture/graphql-client';

import { API_CLIENTS } from '../../../config/constants';
import * as FETCH_COMPANY_USERS from './gql/company.users.gql';

export const getCompanyUsers = (id: string): Promise<User[]> => {
  return graphqlClient
    .getClient(API_CLIENTS.graphqlClient)
    .query<{ company: { users: User[] } }>({
      query: FETCH_COMPANY_USERS,
      fetchPolicy: 'network-only',
      variables: {
        id,
      },
    })
    .then((response) => {
      return response.data.company.users;
    });
};
